import { Color, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Pressable, PressableProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { GeoResult } from 'zens-store'

const COLOR_VERY_LIGHT_GREY_BLUE = '#EDF7FF'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    paddingHorizontal: Spacing.S,
    paddingVertical: Spacing.XS,
    flexDirection: 'row',
    alignItems: 'center',
  },
  hovered: {
    backgroundColor: COLOR_VERY_LIGHT_GREY_BLUE,
  },
  pressed: {
    backgroundColor: Color.lightGreyBlue,
  },
})

interface Props extends Omit<PressableProps, 'style'> {
  result: GeoResult
  style?: StyleProp<ViewStyle>
}
const Result = (props: Props) => {
  const { result, style, ...otherProps } = props

  const renderContent = (state: { pressed: boolean; hovered?: boolean }) => {
    const { title } = result
    const { pressed, hovered } = state

    return (
      <View style={[styles.content, hovered && styles.hovered, pressed && styles.pressed]}>
        <Text>{title}</Text>
      </View>
    )
  }
  return (
    <Pressable style={[styles.container, style]} {...otherProps}>
      {renderContent}
    </Pressable>
  )
}

export default Result
